import { Icon, Stack } from '@fluentui/react';
import { IconName, useTheme } from '@h2oai/ui-kit';

import { OperationError } from '../hooks/useOperationErrors';

interface OperationErrorDisplayProps {
  error: OperationError;
}

export const OperationErrorDisplay = ({ error }: OperationErrorDisplayProps) => {
  const { palette } = useTheme();

  return (
    <Stack
      horizontal
      tokens={{ childrenGap: 8 }}
      style={{ color: palette?.red500 }}
      verticalAlign="center"
      role="alert"
      aria-live="polite"
    >
      <Icon iconName={IconName.Error} aria-hidden="true" />
      <span>
        {error.type.charAt(0).toUpperCase() + error.type.slice(1)} failed: {error.message}
      </span>
    </Stack>
  );
};
